module.exports = __webpack_public_path__ + "static/media/checkmark-icon.e614b603.png";